class MobileNav {
  constructor (navBtnSelector) {
    this.btns = document.querySelectorAll(navBtnSelector)

    this.toggleSubMenu = this.toggleSubMenu.bind(this)
    this.init()
  }

  init () {
    this.btns.forEach(btn => {
        console.log(btn)
        btn.addEventListener('click', this.toggleSubMenu)
    })
  }

  toggleSubMenu (evt) {
    if (window.innerWidth < 1000) {
      evt.preventDefault()
    }
    evt.target.closest('.footer-block--menu').classList.toggle('menu-item--open')
    evt.stopImmediatePropagation()
    return false
  }

  collapseSubMenus () {
    const openMenuItems = document.querySelectorAll('.menu-item--open')
    openMenuItems.forEach(item => {
      item.classList.remove('menu-item--open')
    })
  }
}

const mobileNav = new MobileNav('.footer-block__mobile-container')

